import { useGetOne } from 'react-admin';

import { CLOUDFLARE_WORKER_API } from '@pumpkincare/config';

export function usePetBreedsBySpecies(species, breedVersion = 'v2') {
  const breedUrl = `${CLOUDFLARE_WORKER_API}/${breedVersion}/breeds/${species}`;

  return useGetOne(
    '',
    {
      id: '',
      meta: {
        api: 'UTILS',
        custom_url: breedUrl,
      },
    },
    { enabled: !!species, placeholderData: [], staleTime: 1000 * 60 * 60 }
  );
}
